
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createcontacto5026b } from '../../api/contacto5026b.api'

import './contactox2m2p.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pcontactox2m2p = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id68e7fbdb8e5aed52dc7f282d" >

      <div id="iw4j" className="">
      
      <div id="iwv3ah" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggu1zyt.png"
        alt="undefined"
      />
      
      <div className="" id="is8n8g">
        <>PETRUS GEMS</>
      </div>
      
      </div>
      
      <div id="i4kmai" className="">
      
        <a
          target=""
          className=""
          id="itw0wk"
          href="tel:+50488951552"
        >
          
    <div id="i3h60u" className="">
    <>+50488951552</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <div id="iowj1k" className="">
      
      <div id="iwg34j" className="">
      
      <a
        target=""
        className="link "
        id="il8xfg"
        href="/"
        type="button"
      >
        
    <div id="ihswfv" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="iuicrj"
        href="/productos"
        type="button"
      >
        
    <div id="ih9i7g" className="">
    <>PRODUCTOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ib4wzs"
        href="/certificaciones"
        type="button"
      >
        
    <div id="ie4p6q" className="">
    <>CERTIFICACIONES</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="itj7od"
        href="/contacto"
        type="button"
      >
        
    <div id="i6b0kg" className="">
    <>CONTACTO</>
    </div>
    
      </a>
      
      </div>
      
      <div id="i0vlk5" className="">
      
        <a
          target=""
          className=""
          id="ihypi2"
          href="/carritocompras"
        >
          
      <img
        className=""
        id="i7mm4p"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgjoujuz.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <img
        className=""
        id="iok6z3"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgjq3ce5.jpg"
        alt="undefined"
      />
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/productos"
        type=""
      >
        <>Productos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/certificaciones"
        type=""
      >
        <>Certificaciones</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3m0i" className="">
      
      <div
        id="iz167x"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="iatovg" className="">
      
      <div id="i02jag" className="">
      
      <div className="" id="i6gj2n">
        <>Ponte en Contacto</>
      </div>
      
      </div>
      
      </div>
      
      <div id="ix54wj" className="">
      
      <div id="ia7df1" className="">
      
      <div className="" id="i6nybl">
        <>¿Tienes preguntas? ¡Hablemos!</>
      </div>
      
      <div className="" id="iniwgh">
        <>Estamos para ayudarte a encontrar esa pieza perfecta que cuente tu historia.</>
      </div>
      
        <div className="" id="ikh2s7">
          
      <form
        id="ifm98k"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createcontacto5026b({
						token: 'aasdas',
						nombret3do9: e.target.nombret3do9.value,
						telefono4uv5s: e.target.telefono4uv5s.value,
						correjzksb: e.target.correjzksb.value,
						undefined: e.target.undefined.value,
					});
					alert("Se envio de manera exitosa.");
		} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="iz3qnf" className="">
      
      <br className="" id="" />
      
      <input
        name="nombret3do9"
        type="text"
        placeholder="Nombre"
        className="input "
        id="iv7zhf"
      />
      
      </div>
      
      <div id="iklbmu" className="">
      
      <br className="" id="" />
      
      <input
        name="telefono4uv5s"
        type="text"
        placeholder="Teléfono"
        className="input "
        id="i29uyq"
      />
      
      </div>
      
      <div id="i0qv5w" className="">
      
      <br className="" id="" />
      
      <input
        name="correjzksb"
        type="text"
        placeholder="Correo"
        className="input "
        id="ir57ck"
      />
      
      </div>
      
    <div id="ii488i" className="">
    
      <br className="" id="" />
      
      <textarea name="mensajeavdvr" className="input " id="Mensaje">
        
      </textarea>
      
    </div>
    
      <button
        type="submit"
        name=""
        id="irkalh"
        className=""
        
      >
      
      <div id="iwgtth" className="">
      <>Enviar</>
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      <div id="ifce5t" className="">
      
      <div id="iq25wf" className="">
      
      <div id="ikum65" className="">
      
      <img
        className=""
        id="i2ux31"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgjr2o1k.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="io0w2j">
        <>+504 8895-1552</>
      </div>
      
      </div>
      
      <div id="ijxjvz" className="">
      
      <div id="i7t5wy" className="">
      
      <img
        className=""
        id="i7qgik"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgjr4ons.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ibjohm">
        <>handalcarl13@gmail.com</>
      </div>
      
      </div>
      
      <div id="i6y8lt" className="">
      
      <div id="i5e40a" className="">
      
      <img
        className=""
        id="i5jpeh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgjr5a23.png"
        alt="undefined"
      />
      
      </div>
      
      <iframe
        title="Mapa"
        className=""
        id="ipmyfv"
        frameBorder="0"
        src="https://maps.google.com/maps?&q=Tegucigalpa&z=4&t=q&output=embed"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        <>Petrus Gems</>
      </div>
      
      <div className="" id="iygu8i">
        <>Elaboración de joyas de forma artesanal por mano de mujeres en nuestras comunidades</>
      </div>
      
      <div id="ix6pbo" className="">
      
        <a
          target=""
          className=""
          id="ibwuje"
          href="https://www.facebook.com/gemspetrus.hn"
        >
          
      <img
        className=""
        id="iy1qpk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiadxwc.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="iqvgxw"
          href="https://www.instagram.com/gemspetrus/"
        >
          
      <img
        className=""
        id="i26xh9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiafdkq.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Enlaces Rápidos</>
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/productos"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Productos</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/certificaciones"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>Certificados</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/contacto"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div id="iincid" className="">
      
      <span className="material-icons " id="iwlmju">
        
      <span className="material-icons " id="iz5z0g">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="i78qcc">
        <>+504 8895-1552</>
      </div>
      
      </div>
      
      <div id="idmnrv" className="">
      
      <span className="material-icons " id="i7tn5m">
        
      <span className="material-icons " id="isg8ci">
        
      <span className="material-icons " id="iuenok">
        <>mail</>
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="il1rnw">
        <>handalcarl13@gmail.com</>
      </div>
      
      </div>
      
      <div id="i2jt24" className="">
      
      <span className="material-icons " id="il9zag">
        
      <span className="material-icons " id="iom84k">
        
      <span className="material-icons " id="i1y0v4">
        
      <span className="material-icons " id="iwl57t">
        <>my_location</>
      </span>
      
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="i1at63">
        <>ubicacion</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcontactox2m2p);
  